import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { USER_TYPE } from 'src/app/core/Constants/static';
import { RuleManagement } from 'src/app/core/Models/interfaces/responseData';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { RuleConfigManageService } from '../../services/rule-config-manage.service';

@Component({
  selector: 'app-rule-manage-listing',
  templateUrl: './rule-manage-listing.component.html',
  styleUrls: ['./rule-manage-listing.component.css']
})
export class RuleManageListingComponent implements OnInit {
  @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
  public ruleManageList?: RuleManagement[] = [];
  totalCount!: number;
  page_no: number = 1;
  sortParams!: string;
  user?: UserDetails;
  page_limit: number = 25;
  columnSort: any = {
    rule: {
      sortType: 'ascending',
    },
    typeOfRule: {
      sortType: 'ascending',
    },
    sortOrder: {
      sortType: 'ascending',
    }
  }
  public fetchingInProgress: boolean = false;

  constructor(private ruleService: RuleConfigManageService,
    private toasterandLoader: ToasterService,
    private userService: UserService) {
    this.user = this.userService.getUserInfo()?.userDetails;
  }

  ngOnInit(): void {

  }
  isScrollIntoViewNeeded() {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }
  currentPageDetail(event: any) {

    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.getAllRuleList();
  }

  public getAllRuleList() {
    this.fetchingInProgress = true;
    this.toasterandLoader.isLoaderEnable(true);

    if (this.user?.userType === USER_TYPE.system && this.checkPermission('getRules')) {

      let filterPayload = {
        page_limit: this.page_limit,
        page: this.page_no,
        sort: this.sortParams,
      }
      this.ruleService.getAllRules(filterPayload).subscribe(res => {
        this.ruleManageList = res?.data?.data
        this.totalCount = res?.data?.total
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      }, err => {
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      })
    } else if (this.user?.userType === USER_TYPE.payer && this.checkPermission('getPayerRuleList')) {

      let filterPayload = {
        per_page: this.page_limit,
        page: this.page_no,
        sort: this.sortParams,
      }
      this.ruleService.getRuleListPayer(filterPayload, this.user?.payerId).subscribe(res => {
        this.ruleManageList = res?.data?.data
        this.totalCount = res?.data?.total
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      }, err => {
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      })
    } else if (this.user?.userType === USER_TYPE.provider && this.checkPermission('getProviderRuleList')) {
      let filterPayload = {
        per_page: this.page_limit,
        page: this.page_no,
        sort: this.sortParams,
      }
      this.ruleService.getRuleListProvider(filterPayload, this.user?.providerId).subscribe(res => {
        this.ruleManageList = res?.data?.data
        this.totalCount = res?.data?.total
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      }, err => {
        this.fetchingInProgress = false;
        this.toasterandLoader.isLoaderEnable(false);
      })
    }

  }

  sortColumn(colName: string) {
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        const element = this.columnSort[key];
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.getAllRuleList();
        }else{
          this.columnSort[key].sortType = 'ascending';
        }

      }
    }
  }

  checkPermission(perName:string):boolean{
    return this.userService.getPermissions(perName);
  }

}
